<template>
  <td :colspan="cols">
    <span style="display: grid">
      <span v-if="subtitle" class="font-weight-bold" style="font-size: 0.7em">{{
        subtitle
      }}</span>
      <span class="font-weight-bold font-size-85">
        <slot />
      </span>
    </span>
  </td>
</template>

<script>
  /* eslint-disable vue/require-default-prop, vue/require-prop-types */
  export default {
    name: 'IELTableCell',

    props: {
      subtitle: {
        type: String,
      },
      cols: {
        type: Number,
        default: 1,
      },
    },
  };
</script>
